import { render, staticRenderFns } from "./DonorCauseOfDeathPrint.vue?vue&type=template&id=7a6d73af"
import script from "./DonorCauseOfDeathPrint.vue?vue&type=script&lang=js"
export * from "./DonorCauseOfDeathPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports